import moment from 'moment'
import { DATE_TIME_FORMAT } from './constants'

export const getNewDateUtcMoment = () => {
  return moment(moment().utcOffset('+09:00').format(DATE_TIME_FORMAT)).toDate()
}
